import { IsOptional, IsNotEmpty, IsString, MaxLength, IsEmail, MinLength, IsArray, IsInt } from "class-validator";

export class TeamEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(50)
    name: string;

    @IsOptional()
    @IsString()
    @MaxLength(3000)
    description: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    phone: string;

    @IsOptional()
    @IsEmail()
    @MaxLength(255)
    email: string;

    @IsNotEmpty()
    @IsInt()
    type: number;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    users: Array<string>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    resourceGroups: Array<string>;

}
